import { render, staticRenderFns } from "./ContenidoSatisfaccionCliente.vue?vue&type=template&id=7e5a4deb&"
import script from "./ContenidoSatisfaccionCliente.vue?vue&type=script&lang=js&"
export * from "./ContenidoSatisfaccionCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports